import React, { useCallback, Fragment, useContext, useState, useEffect, useRef } from 'react';
import { PlugButton } from 'app/home/main-pages/devices/Devices'
import { LocalizationContext } from 'app/localization/Context';
import { DeviceDetailSecondPageAnimator } from '../DeviceDetail';
import { PowerChart, prepareLineChartWithGap } from '../../../../general-components/Charts/PowerChart';
import { useElementSize } from 'usehooks-ts';
import momentj from 'moment-jalaali';

import { ReactComponent as IconBack } from 'images/general/back.svg';
import { ReactComponent as IconDown } from 'images/general/down.svg';
import { ReactComponent as IconLoading } from 'images/general/clone-of-connecting-white.svg';

import './All.scss'

function Button({ on, onClickHandler, darkerBorder, waitingForChangeState, canStateBeNoChange }) {
    return (
        <div className={"border " + (darkerBorder ? "darker" : "lighter")}>
            <PlugButton on={on} onClickH={onClickHandler} showStates={true}
                // canStateBeNoChange={true}
                waitingForChangeState={waitingForChangeState} />
        </div>
    )
}

export function PlugControl({ device, darkerBorder, canStateBeNoChange }) {
    const onClickH = useCallback((key) => {
        return (event) => {
            event.preventDefault();
            let changeStateObject = {}

            // if (canStateBeNoChange) { // only in scenario creation
            //     if (device[key] === false) {
            //         changeStateObject[key] = true;
            //     } else if (device[key] === true) {
            //         changeStateObject[key] = undefined;
            //     } else {
            //         changeStateObject[key] = false;
            //     }
            // } else {
            changeStateObject[key] = !device[key]
            // }

            device.changeState(changeStateObject);
        }
    }, [device]);
    // }, [device, canStateBeNoChange]);

    const containerClass = device.active ?
        "device-detail-control active" : "device-detail-control inactive";

    return (
        <div className={containerClass}>
            <Button
                on={device.state}
                onClickHandler={onClickH("state")}
                darkerBorder={darkerBorder}
                waitingForChangeState={device.waitingForChangeState["state"]} />
        </div>
    );
}

export function WinepControl({ device, darkerBorder }) {
    const onClickH = useCallback((key) => {
        return (event) => {
            event.preventDefault();
            let changeStateObject = {}
            changeStateObject[key] = !device[key]
            device.changeState(changeStateObject);
        }
    }, [device]);

    const containerClass = device.active ?
        "device-detail-control winep-frame active" : "device-detail-control winep-frame inactive";

    return (
        <div className={containerClass}>
            <div className="leds">
                <div className="led" />
                <div className="led" />
                <div className="led" />
                <div className="led" />
            </div>
            <Button on={device.state1}
                onClickHandler={onClickH("state1")}
                darkerBorder={darkerBorder}
                waitingForChangeState={device.waitingForChangeState["state1"]} />
            <Button on={device.state2}
                onClickHandler={onClickH("state2")}
                darkerBorder={darkerBorder}
                waitingForChangeState={device.waitingForChangeState["state2"]} />
            <Button on={device.state3}
                onClickHandler={onClickH("state3")}
                darkerBorder={darkerBorder}
                waitingForChangeState={device.waitingForChangeState["state3"]} />
            <Button on={device.state4}
                onClickHandler={onClickH("state4")}
                darkerBorder={darkerBorder}
                waitingForChangeState={device.waitingForChangeState["state4"]} />
        </div>
    );
}

export function PowerStat({ requestGetPower, device, showPowerReportPage, setShowPowerReportPage }) {
    const l = useContext(LocalizationContext);
    const sp = l.strings.power;

    if (device.power === undefined)
        return null;

    return (<Fragment>
        <div className="power-section">
            <div className="header">
                <div className="title">{sp.stat}</div>
                <div />
                <div className="button"
                    onClick={() => setShowPowerReportPage(true)}>
                    {sp.showReport}
                </div>
            </div>

            <div className="current">{
                l.language === 'en' ?
                    String(device.power) + " W"
                    : l.localizeNumber(String(device.power)) + " وات"
            }</div>
        </div>

        {/* Chart Page */}
        <DeviceDetailSecondPageAnimator isActive={showPowerReportPage}>
            <PowerReportPage requestGetPower={requestGetPower} device={device} dismiss={() => setShowPowerReportPage(false)} />
        </DeviceDetailSecondPageAnimator>
    </Fragment>);
}

function PowerReportPage({ requestGetPower, device, dismiss }) {
    const l = useContext(LocalizationContext);
    const sp = l.strings.power;

    const [pageRef, { width: pageWidth }] = useElementSize();

    const [preparedData, setPreparedData] = useState([undefined, undefined, undefined, undefined, undefined]);
    const [singlePoints, lines, gaps, dateBound, powerBound] = preparedData;

    const [isPopupActive, setPopupActive] = useState(false);
    const [duration, setDuration] = useState("last1"); // last1, last7, last30
    const [dateFormatter, setDateFormatter] = useState(undefined); // hours, weekdays, days
    const powerFormatter = useCallback((p) => {
        return l.localizeNumber(p + " W");
    }, [l]);

    const deviceMac = device.mac;
    const callbackIdRef = useRef(Math.floor(Math.random() * 10000000000));
    const setNewCallbackId = useCallback(() => {
        callbackIdRef.current = Math.floor(Math.random() * 10000000000);
    }, [callbackIdRef]);

    const chooseDurationH = useCallback((d) => {
        return () => {
            setNewCallbackId();
            setDuration(d);
            switch (d) {
                case "last30":
                    setDateFormatter({
                        format: (date) => { // days
                            if (l.language === 'en') {
                                momentj.locale("en")
                                return momentj(date).format("M/D");
                            } else if (l.language === 'fa') {
                                momentj.locale("fa")
                                return l.localizeNumber(momentj(date).format("jM/jD"));
                            } else if (l.language === 'ar') {
                                momentj.locale("ar")
                                return momentj(date).format("M/D");
                            }
                        }
                    });
                    break;
                case "last7":
                    setDateFormatter({
                        format: (date) => { // weekdays
                            if (l.language === 'en') {
                                momentj.locale("en")
                            } else if (l.language === 'fa') {
                                momentj.locale("fa")
                            } else if (l.language === 'ar') {
                                momentj.locale("ar")
                            }
                            return momentj(date).format("ddd");
                        }
                    });
                    break;
                case "last1":
                default:
                    setDateFormatter({
                        format: (date) => { // hours
                            return l.localizeNumber(momentj(date).format("HH:mm"));
                        }
                    });
                    break;
            }
            setPopupActive(false);
        };
    }, [l, setNewCallbackId]);

    useEffect(() => {
        momentj.locale("en")
        let to = momentj();
        let from = momentj();
        let step = undefined;

        switch (duration) {
            case "last30":
                step = 60 * 12; // 0.5 rooz
                from.subtract(30, "days");
                break;
            case "last7":
                step = 60 * 12; // 0.5 rooz
                from.subtract(7, "days");
                break;
            case "last1":
            default:
                step = 60; // 1 saat
                from.subtract(1, "days");
                break;
        }

        if (dateFormatter === undefined) {
            chooseDurationH("last1")();
            return; // will call itself again!
        }
        setPreparedData([undefined, undefined, undefined, undefined, undefined]);

        const tempcallbackId = callbackIdRef.current;
        requestGetPower(tempcallbackId, (data) => {
            // let c = data.length;
            // data = [];
            // for (let i = 0; i < c; i++) {
            //     data.push(0);            
            // }

            if (callbackIdRef.current === tempcallbackId) {
                setPreparedData(prepareLineChartWithGap(from.toDate(), step * 60 * 1000, data));
            }
        }, deviceMac, from.format("YYYY-MM-DD HH:mm:ss"), to.format("YYYY-MM-DD HH:mm:ss"), step);
    }, [requestGetPower, callbackIdRef, deviceMac, duration, dateFormatter, chooseDurationH]);

    return (
        <div className="power-report-page" ref={pageRef}>
            <div className="bg-blank" />
            <div className="bg-secondary-color" />
            <div className="power-report-page-content">
                <IconBack className="nav-icon" />
                <div className="nav-button" onClick={dismiss} />

                <div className="section-title">{sp.current}</div>
                <div className="current-power">{
                    (l.language === 'en') ?
                        String(device.power) + " W"
                        : l.localizeNumber(String(device.power)) + " وات"
                }</div>

                <div className="chart-header">
                    <div className="text">{sp.statistics}</div>
                    <div />
                    <div className="button">
                        <div className="text"
                            onClick={() => setPopupActive(!isPopupActive)}>
                            {sp[duration]}
                        </div>
                        <IconDown className="icon"
                            onClick={() => setPopupActive(!isPopupActive)} />

                        <div className={"drop-down " + (isPopupActive ? "active" : "inactive")}>
                            <div className={"item top " + (duration === "last1" ? "selected" : "")}
                                onClick={chooseDurationH("last1")}>
                                <div>{sp.last1}</div>
                            </div>
                            <div className={"item middle " + (duration === "last7" ? "selected" : "")}
                                onClick={chooseDurationH("last7")}>
                                <div>{sp.last7}</div>
                            </div>
                            <div className={"item bottom " + (duration === "last30" ? "selected" : "")}
                                onClick={chooseDurationH("last30")}>
                                <div>{sp.last30}</div>
                            </div>
                        </div>
                    </div>
                </div>

                {
                    lines !== undefined ?
                        <PowerChart
                            chartKey={"plug-mac-" + deviceMac} className="chart"
                            width={pageWidth - 16}
                            height={300} duration={duration}
                            margin={{ top: 20, left: 45, right: 8, bottom: 20 }}
                            singlePoints={singlePoints} lines={lines} gaps={gaps} dateBound={dateBound} powerBound={powerBound}
                            dateFormatter={dateFormatter} powerFormatter={powerFormatter}
                        />
                        : <Loading text={sp.loading} />
                }
            </div>
        </div>
    )
}

function Loading({ text }) {
    return (
        <div className="loading">
            <IconLoading className="icon" />
            <div className="text">{text}</div>
        </div>
    )
}